import React from 'react'

export const StateLabel = ({state}) => {
  if (!state) return null
  if (state === 'activated') return null
  return <span className={`label label-${state}`}>{I18n.t(`misc.state_label_${state}`)}</span>
}
